var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"roller-loader",style:({ '--size': `${_vm.size}px` })})
}
var staticRenderFns = []

export { render, staticRenderFns }